/* WARNING: This file is auto-generated . Do not edit manually. */

import { OrderPrice } from './OrderPrice';

export type CloudProjectStorageVolumeUsage = {
  region?: string;
  storedBytes?: number;
  total?: OrderPrice;
};
